module.exports = __webpack_public_path__ + "static/media/undo-white.ade9a360.svg";